import React from 'react'
import styles from './ScopesSection.module.scss'
import { SectionContainer } from '../SectionContainer'
import { Scope } from './Scope'
import { ScopesSectionProps } from './ScopesSection.types'
import { Button } from 'components/common'
import { IconPlusSquare } from 'assets'
import { newScope } from '../agreement-model-templates'

const ScopesSectionComponent = (props: ScopesSectionProps) => {
  const { scopes, setScopes } = props

  return (
    <SectionContainer label='Scopes' className={styles.container}>
      <Button
        className={styles.addScopeBttn}
        onClick={() => setScopes([...scopes, newScope])}
      >
        <IconPlusSquare />
        Add scope
      </Button>
      {scopes.map((scope, index) => {
        return (
          <Scope
            key={index}
            scope={scope}
            setScopeProp={newScopeProps => {
              const newScopes = [...scopes]
              newScopes[index] = { ...newScopes[index], ...newScopeProps }
              setScopes(newScopes)
            }}
            remove={() => {
              const newScopes = [...scopes]
              newScopes.splice(index, 1)
              setScopes(newScopes)
            }}
          />
        )
      })}
    </SectionContainer>
  )
}

const ScopesSection = ScopesSectionComponent
export { ScopesSection }
